import { BoxProps } from '@chakra-ui/react'

export function disabledStyles(isDisabled: boolean): BoxProps {
    return {
        filter: isDisabled ? 'grayscale(100%)' : 'none',
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? 'none' : 'initial',
    } as BoxProps
}
